module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._v("\n\t\t\t\t-- " + _vm._s(_vm.userRoles[0]) + " --\n\t\t\t\t"), _c('br'), _c('br'), _vm._v("\t\t\t\n\t\t\t\t-- " + _vm._s(_vm.roleId) + " --\n\t\t\t")])], 1)], 1)
},staticRenderFns: []}